import { ReactElement } from "react";
import { Button, Icon } from "@atoms";

const colors = require("@theme/colors") as Record<string, any>;

export type CardListBaseTemplateProps = {
  title: string;
  onClick: (() => void) | undefined;
  buttonText?: string;
  hasTransactionFee?: boolean;
  hasAddButton?: boolean;
  data: any;
  children: ReactElement;
  icon?: JSX.Element;
  iconSubtitle?: string;
};

export const CardListBaseTemplate = ({
  title,
  onClick,
  buttonText = "",
  hasTransactionFee = false,
  hasAddButton = false,
  data,
  children
}: CardListBaseTemplateProps): JSX.Element => {
  const hasData = data !== null && data !== undefined && data?.length > 0;
  const isEmpty = data !== null && data !== undefined && data?.length === 0;
  const shouldUseOutlineStyle = hasAddButton && onClick !== undefined && hasData;

  const actionButton =
    hasAddButton && data !== null
      ? shouldUseOutlineStyle
        ? (
            <Button
              onClick={onClick}
              variant="secondary"
              label={buttonText}
              autosize
              color="#FFFFFF"
              hoverColor="#FFE8D6"
              textColor={colors.primary.medium}
              borderColor={colors.primary.medium}
              fontWeight={600}
            />
          )
        : (
            <Button
              onClick={onClick}
              variant="primary"
              label={buttonText}
              autosize
              textWeight="semibold"
              color={
                onClick !== undefined && isEmpty
                  ? "primary-medium"
                  : "neutral-lightest"
              }
              textColor={
                onClick !== undefined && isEmpty
                  ? "white"
                  : "neutral-darkest"
              }
              hoverColor={
                onClick !== undefined && isEmpty
                  ? "primary-dark"
                  : "neutral-light"
              }
            />
          )
      : null;

  return (
    <div className="mb-4 w-full" style={{ maxWidth: "100%" }}>
      <div className="rounded-2xl border border-neutral-light bg-white p-6 pt-5 w-full h-full flex flex-col gap-5">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <div className="section-title mt-1">{title}</div>
            {hasTransactionFee ? (
              <div className="px-2 py-0.5 rounded-full text-neutral-darkest text-xs bg-neutral-lighter">
                3% fee
              </div>
            ) : null}
          </div>
          {actionButton ? <div className="flex justify-start sm:justify-end">{actionButton}</div> : null}
        </div>
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
};
